<template>
  <div class="mb-4">
    <validation-observer ref="cbObserver" v-slot="{ errors }">
      <validation-provider :rules="{ cbRequired: !isOptional ? { question, stateResponse, stateResponseTextValue } : false }" :disabled="isOptional" :immediate="validateImmediate">
        <div v-for="(error, name) in errors" :key="name">
          <h6 v-if="displayError(error, number + question.questionText)" class="text-danger">{{ error[0] }}</h6>
        </div>
        <div :style="{ 'background-color': questionBackColor }"><span v-html="number" class="number-text"></span><span v-html="question.questionText"></span></div>
        <div class="font-italic mb-1">{{ question.instructions }}</div>
        <span v-if="debugQuestions" class="text-warning">{{ question.hspCategoryQuestionId }} (state: {{ stateResponse }}, text: {{ stateResponseTextValue }}))</span>
        <div :style="{ 'background-color': responsesBackColor }">
          <div v-for="response in responses" :key="response.hspResponseId">
            <base-checkbox
              :exclusiveSelected="exclusiveSelected"
              :hspResponseId="response.hspResponseId"
              :isExclusive="response.hspResponseTypeId == 1"
              :checked="isChecked(response.hspResponseId, response.hspResponseTypeId)"
              :textValue="stateResponseTextValue"
              @input="handleInput"><span v-html="response.responseTitle"></span></base-checkbox>
            <div class="mt-1" v-if="response.hspResponseTypeId == 2">
              <base-input
                :value="stateResponseTextValue"
                @input="handleTextChange"
                :disabled="!isChecked(response.hspResponseId, response.hspResponseTypeId)"
                :hspResponseId="response.hspResponseId"></base-input>
            </div>
            <div class="mt-1" v-else-if="response.hspResponseTypeId == 3">
              <base-input
                :value="stateResponseTextValue"
                @input="handleTextChange"
                :disabled="!isChecked(response.hspResponseId, response.hspResponseTypeId)"
                :isMultiline="true"
                :hspResponseId="response.hspResponseId"></base-input>
            </div>
          </div>
        </div>
      </validation-provider>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import { getResponses } from 'src/modules/utils';

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    question: {
      type: Object,
      required: true,
      default: function() {
        return {
          responses: []
        }
      }
    },
    number: String,
    questionBackColor: String,
    responsesBackColor: String,
    sectionId: {
      type: Number,
      required: true,
      description: 'Needed to disable validation when section is not active.'
    },
    validateImmediate: Boolean,
  },
  data() {
    return {
      exclusiveSelected: false,
      responses: []
    }
  },
  computed: {
    ...mapGetters(['activeSectionId', 'debugQuestions']),
    isDisplayed() {
      return this.sectionId === this.activeSectionId;
    },
    isOptional() {
      if(this.isDisplayed && this.question.isRequired === true) {
        return false;
      }

      return true;
    },
    stateResponse() {
      return this.$store.getters.getQuestionResponseIds(this.question.hspCategoryQuestionId);
    },
    stateResponseTextValue() {
      let responses = this.$store
        .getters
        .getQuestionResponses(this.question.hspCategoryQuestionId)
        .filter(response => response.hspResponseTypeId == 2);

      if(responses.length) {
        return responses[0].responseTextValue;
      }

      return null;
    },
    hasResponseTriggers() {
      return this.question.responseTriggers.length > 0;
    },
  },
  methods: {
    displayError(error, description = "") {
      let display = error.length > 0 && error[0].length > 0;
      // console.log("In Checkboxes.vue -- error:");
      // console.log(error);
      // console.log((description.length > 0 ? "for [" + description + "]: " : "") + "display = [" + display + "]");
      return display;
    },
    isChecked: function(hspResponseId, hspResponseTypeId) {
      if(this.stateResponse.indexOf(hspResponseId) >= 0) {
        return true;
      }
      else if(hspResponseTypeId !== 1 && this.exclusiveSelected) {
        return false;
      }
      else if(hspResponseTypeId === 1 && !this.exclusiveSelected) {
        return false;
      }

      return false;
    },
    handleInput: function(value, params) {
      this.$store.dispatch('setCheckboxesQuestionResponse', {
        include: value,
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseId: params.hspResponseId,
        isExclusive: params.isExclusive,
        hasTextField: false
      });

      if(params.isExclusive) {
        this.exclusiveSelected = value;
      }
      else {
        this.exclusiveSelected = false;
      }

      this.handleResponseTriggers(params.hspResponseId);
      this.$refs.cbObserver.reset();
    },
    handleTextChange(value, hspResponseId) {
      this.$store.dispatch('setCheckboxTextResponse', {
        questionTypeId: this.question.hspQuestionTypeId,
        questionId: this.question.hspCategoryQuestionId,
        responseId: hspResponseId,
        isExclusive: false,
        hasTextField: true,
        responseText: value
      });
    },
    boxChecked(id) {
      let found = this.stateResponse.find(x => x == id);
      if (found) {
        return true;
      }

      return false;
    },
    getTriggersByValue(delim) {
      return this.question.responseTriggers.filter(x =>
        x.triggerResponseValue != null 
        && x.triggerResponseValue !== '' 
        && x.triggerResponseValue.indexOf(delim) >= 0)
    },
    getAndTrigger(responseIds) {
      if (!this.hasResponseTriggers) {
        return null;
      }
      let delim = ",";
      let responseTrigger = null;
      let triggers = this.getTriggersByValue(delim);
      if (triggers) {
        responseTrigger = triggers.find(trigger => {
          let values = trigger.triggerResponseValue.split(delim);
          let matches = 0;
          responseIds.forEach(x => {
            if (values.includes(x.toString())) {
              matches++;
            }
          });

          if (matches === values.length) {
            return true;
          }

          return false;          
        });
      }

      return responseTrigger;
    },
    getOrTrigger(responseIds) {
      if (!this.hasResponseTriggers) {
        return null;
      }

      // Check for the 'or' list
      let delim = "|";
      let responseTrigger = null;
      let triggers = this.getTriggersByValue(delim);
      if (triggers) {
        responseTrigger = triggers.find(trigger =>
          responseIds.find(x => trigger.triggerResponseValue.indexOf(x.toString()) >= 0)
        );
      }

      return responseTrigger;
    },
    handleResponseTriggers(value) {
      if (this.hasResponseTriggers) {
        // Checked/unchecked verification
        // In case the value passed in is the checkbox that got unchecked, get the next checked item, if any.
        // NOTE: This check is not necessary for response triggers to work correctly. But it is the proper way
        //       to handle check boxes because they can be checked or unchecked. This is also another layer to
        //       properly make response triggers work for check boxes in case the standard page validation fails. 
        //       
        //       Explanation:
        //       Regardless of whether the parameter value
        //       is an item that was checked or unchecked, and is used in retrieving the responseTrigger object below,
        //       this item belongs to this group of check boxes or mutually exclusive set of check boxes. Even if all the
        //       check boxes in the group are unchecked and a responseTrigger object is able to be retrieved to dispatch
        //       a branching target event (erroneously if the parameter is an unchecked item), the user would not be able to 
        //       proceed to the next section because at least one check box is required to contine.
        let responseTrigger = null;

        // But first, let's check for multiple checkboxes. Search for multiple inclusive 'and' combinations, and 'or' combinations.
        // If the selected responses trigger both combinations, check the priorty (set in the triggerOrdinal field) to determine
        // which trigger to use. Lower number value has higher priority.
        if (this.stateResponse.length > 1) {
          let inclusionTrigger = this.getAndTrigger(this.stateResponse);
          let orTrigger = this.getOrTrigger(this.stateResponse);
          if (inclusionTrigger && orTrigger) {           
            // Default to inclusion trigger.
            responseTrigger = inclusionTrigger;
            
            // If both trigger ordinals have values (not null).
            if (inclusionTrigger.triggerOrdinal !== null && orTrigger.triggerOrdinal !== null) {
              if (orTrigger.triggerOrdinal < inclusionTrigger.triggerOrdinal) {
                responseTrigger = orTrigger;
              }
            }
            // Non-null trigger ordinals have precedence over null triggerOrdinal.
            else if (orTrigger.triggerOrdinal !== null) {
              responseTrigger = orTrigger;
            }
          }
          else if (inclusionTrigger) {
            responseTrigger = inclusionTrigger;
          }
          else if (orTrigger) {
            responseTrigger = orTrigger;
          }
        }
        // Standard checking for the trigger response ID.
        else if (this.stateResponse.length > 0) {
          let responseId = value;
          let indexOf = this.stateResponse.indexOf(responseId);
          if (indexOf < 0) {
            responseId = this.stateResponse[0];
          }
          responseTrigger = this.question.responseTriggers.find(trigger => trigger.triggerResponseId === responseId);
          if (!responseTrigger) {
            // No standard response trigger found. Check for the 'or' trigger(s) checkbox list.
            let responseIds = [responseId];
            responseTrigger = this.getOrTrigger(responseIds);
          }
        }
        // End Checked/unchecked verification

        if(responseTrigger) {
          this.$store.dispatch('setTargetSection', responseTrigger);
        }
        else {
          this.$store.dispatch('clearTargetSectionId', this.sectionId);
          this.$emit('triggercleared');
        }
      }
    },
  },
  watch: {
    isDisplayed: function(value) {
      if(value === true) {
        // The 'this.stateResponse' object always holds a list of checked items, or a list of related checked items 
        // if there are more than one set of mutually exclusive responses that trigger a response/branch logic.
        // So, use the first element in the set of related checkboxes for handling response trigger.
        this.handleResponseTriggers(this.stateResponse[0]);
      }
    }
  },
  created() {
    this.responses = getResponses(this.question);
  }
}
</script>
